import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="account-health--records-window"
//
// Toggles the Records Processed card between its precomputed 7/30/90-day values (all three
// are rendered server-side; this just swaps which is visible and which pill reads active).
export default class extends Controller {
  static targets = ["value", "pill"]

  select(event) {
    const window = event.currentTarget.dataset.window

    this.valueTargets.forEach((el) => el.classList.toggle("hidden", el.dataset.window !== window))
    this.pillTargets.forEach((el) => {
      const active = el.dataset.window === window
      el.classList.toggle("bg-sg-success-light", active)
      el.classList.toggle("text-sg-success-dark", active)
      el.classList.toggle("text-sg-gray-500", !active)
    })
  }
}
